import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root"
})
export class ProgressTimeService {

    private currTime: string = "00:02:20";

    public getCurrentTime(): string {
        return this.currTime;
    }
    public resetCurrentTime(): void {
        
        this.currTime = "00:02:20";
    }

    public getTimeForProgress(progress:number): string {
        
        let totalSeconds = 140; // 2min 20sec
        let seconds = Math.round(progress  * 1.4);
        
        let secondsLeft = totalSeconds - seconds;
        
        return this.getTimeInMinutes(secondsLeft);
    }
    
    public getTimeInMinutes(secondsLeft: number): string {

        if (secondsLeft == null) {
            return undefined;
        }
        let minutes = Math.floor(secondsLeft / 60);
        secondsLeft = secondsLeft % 60;
        
        // 140 : x = 100 : progress
        // x = (140 * progress) / 100

        let timeStr = "";
        if (minutes > 0) {
            timeStr += minutes + ":";
        } else {
            timeStr += "00:";
        }
        if (secondsLeft > 0) {
            
            timeStr += secondsLeft;
        } else {
            timeStr += "00";
        }

        this.currTime = timeStr;
        return this.currTime;
    }

}